import axios from 'axios';
import { axiosClient } from '../helpers/axiosClient';

export const AuthenticationServices = {

  // Check user has authenticated
  checkIsLogin: () => { 
    const url = 'api/auth/user';
    return axiosClient.get(url);
  },

  // Login user with azure token
  loginWithAzureId: (token: string) => {
    const url = `${window?.env?.NX_API_BASE_URL || process.env.NX_API_BASE_URL}` + 'api/auth/user';
    return axios.get(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
  },
  // Login with token form demo hub
  loginWithToken: (params: { accessToken: string, productId: string }) => {
    const url = `${window?.env?.NX_API_BASE_URL || process.env.NX_API_BASE_URL}` + 'api/auth/signin';
    return axios.post(url, params);
  },

  // logout user and remove auth token
  logout: () => {
    localStorage.removeItem('user_login');
    // window.location.replace('/login');
  },

  // Get user token
  getToken: () => {
    const info: string | null = localStorage.getItem('user_login');
    if (info === null) {
      return null;
    }
    return JSON.parse(info)?.token || null;
  },
};
